var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    attrs: {
      "id": "searchArea"
    }
  }, [_c('el-form', {
    staticClass: "el-form-filter",
    attrs: {
      "inline": true,
      "model": _vm.dataForm
    },
    nativeOn: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDataList(1);
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    staticClass: "wd500 input-with-select-lg",
    class: {
      hideInputActive: _vm.dataForm.noClientCodeInQuotation || _vm.dataForm.noLinkedEngagement
    },
    attrs: {
      "placeholder": _vm.kwPlaceHolder
    },
    model: {
      value: _vm.dataForm.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "keyword", $$v);
      },
      expression: "dataForm.keyword"
    }
  }, [_c('el-select', {
    attrs: {
      "slot": "prepend",
      "placeholder": "please select"
    },
    on: {
      "change": _vm.kwTypeChange
    },
    slot: "prepend",
    model: {
      value: _vm.dataForm.kwType,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "kwType", $$v);
      },
      expression: "dataForm.kwType"
    }
  }, _vm._l(_vm.kwTypes, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "Country of Company"
    },
    model: {
      value: _vm.dataForm.country,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "country", $$v);
      },
      expression: "dataForm.country"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "select coordinator",
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.coordinatorIds,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "coordinatorIds", $$v);
      },
      expression: "dataForm.coordinatorIds"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Unassigned",
      "value": -1
    }
  }), _vm._l(_vm.userList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.nickname || item.username,
        "value": item.id
      }
    });
  })], 2)], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "select reviewer",
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.auditorIds,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "auditorIds", $$v);
      },
      expression: "dataForm.auditorIds"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Unassigned",
      "value": -1
    }
  }), _vm._l(_vm.userList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.nickname || item.username,
        "value": item.id
      }
    });
  })], 2)], 1), _c('el-form-item', [_c('el-select-all', {
    attrs: {
      "optionList": _vm.applymentStatusExcludeDraftList,
      "placeholder": "Status"
    },
    on: {
      "elSelectAllChange": function elSelectAllChange(list) {
        _vm.dataForm.applymentStatus = list;
      }
    }
  })], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Entity Type"
    },
    model: {
      value: _vm.dataForm.businessGenre,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "businessGenre", $$v);
      },
      expression: "dataForm.businessGenre"
    }
  }, _vm._l(_vm.entityTypes, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Active Status"
    },
    model: {
      value: _vm.dataForm.isForfeited,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "isForfeited", $$v);
      },
      expression: "dataForm.isForfeited"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Active",
      "value": false
    }
  }), _c('el-option', {
    attrs: {
      "label": "In-active",
      "value": true
    }
  })], 1)], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Supplier"
    },
    model: {
      value: _vm.dataForm.supplierId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "supplierId", $$v);
      },
      expression: "dataForm.supplierId"
    }
  }, _vm._l(_vm.supplierList, function (item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.companyName,
        "value": item.id
      }
    });
  }), 1)], 1), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "debounce",
      rawName: "v-debounce"
    }],
    attrs: {
      "icon": "el-icon-search",
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function click($event) {
        return _vm.getDataList(1);
      }
    }
  }, [_vm._v("Search")])], 1)], 1)], 1), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.dataListLoading,
      expression: "dataListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "max-height": "660",
      "data": _vm.dataList,
      "default-sort": {
        prop: 'inquiryTime',
        order: 'descending'
      }
    },
    on: {
      "sort-change": _vm.tableSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "applymentNo",
      "align": "center",
      "label": "Quotation No.",
      "fixed": "left",
      "width": "130"
    }
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Supplier",
      "fixed": "left",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.supplierAbbrDeduplicateFormat(scope.row.supplierList)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "inquiryTime",
      "align": "center",
      "label": "First Request Time",
      "width": "180",
      "sortable": "custom"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "latestInquiryTime",
      "align": "center",
      "label": "Latest Remind Time",
      "width": "160"
    }
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Client Code",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row$quotationL;

        return [((_scope$row$quotationL = scope.row.quotationList) === null || _scope$row$quotationL === void 0 ? void 0 : _scope$row$quotationL.length) > 0 ? _c('span', [_vm._v(_vm._s(_vm.clientCodeDeduplicateFormat(scope.row.quotationList)))]) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "applymentStatus",
      "align": "center",
      "label": "Status",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.applymentStatusFormat(scope.row.applymentStatus)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Linked Engagement ID",
      "width": "184"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row$engagement;

        return [((_scope$row$engagement = scope.row.engagementList) === null || _scope$row$engagement === void 0 ? void 0 : _scope$row$engagement.length) > 0 ? _c('span', [_vm._v(_vm._s(_vm.engagementIdDeduplicateFormat(scope.row.engagementList)))]) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Entity Name",
      "width": "360"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row, _scope$row$fundInfoLi, _scope$row$fundInfoLi2;

        return [_vm._l(_vm.proposedCompanyNameFormat(scope.row), function (name, index) {
          return _c('div', {
            key: "entityName-".concat(scope.row.id, "-").concat(index)
          }, [_vm._v(" " + _vm._s(name) + " ")]);
        }), ((_scope$row = scope.row) === null || _scope$row === void 0 ? void 0 : (_scope$row$fundInfoLi = _scope$row.fundInfoList) === null || _scope$row$fundInfoLi === void 0 ? void 0 : _scope$row$fundInfoLi.length) > 0 ? _c('div', [_vm._v(" " + _vm._s((_scope$row$fundInfoLi2 = scope.row.fundInfoList.map(function (item) {
          return item.fundName;
        })) === null || _scope$row$fundInfoLi2 === void 0 ? void 0 : _scope$row$fundInfoLi2.join(", ")) + " ")]) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "businessGenre",
      "align": "center",
      "label": "Entity Type",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.entityTypeFormat(scope.row.businessGenre)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "applicantName",
      "align": "center",
      "label": "Applicant Name",
      "width": "140"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "applicantEmail",
      "align": "center",
      "label": "Applicant Email",
      "width": "180"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "country",
      "align": "center",
      "label": "Country of Company",
      "width": "180"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "coordinator",
      "align": "center",
      "label": "Coordinator",
      "width": "180",
      "formatter": _vm.operatorStaffFormat
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "auditor",
      "align": "center",
      "label": "Reviewer",
      "width": "180",
      "formatter": _vm.operatorStaffFormat
    }
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Action",
      "fixed": "right",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.detailHandler(scope.row.id);
            }
          }
        }, [_vm._v("Detail")]), _vm.isAuth('quotation:forfeit') && !scope.row.hasPaid && scope.row.applymentStatus != 'FORFEITED' ? _c('el-button', {
          staticClass: "fwb ml0",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.statusUpdateHandle(scope.row, 'Forfeit');
            }
          }
        }, [_vm._v(" Forfeit ")]) : _vm._e(), _vm.isAuth('quotation:reActive') && !scope.row.hasPaid && scope.row.applymentStatus == 'FORFEITED' ? _c('el-button', {
          staticClass: "fwb ml0",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.statusUpdateHandle(scope.row, 'Re-active');
            }
          }
        }, [_vm._v(" Re-active ")]) : _vm._e(), ['QUOTATION_AUDITING', 'QUOTATION_AUDIT_PASS', 'QUOTATION_AUDIT_FAIL', 'SUBMITTED'].includes(scope.row.applymentStatus) ? [scope.row.hasPaid == 0 ? [_vm.isAuth('quotation:requote') ? _c('el-button', {
          staticClass: "fwb ml0",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.requoteHandle(scope.row);
            }
          }
        }, [_vm._v("Requote")]) : _vm._e()] : _vm._e()] : _vm._e()];
      }
    }])
  })], 1), _c('pagination', {
    attrs: {
      "current": _vm.current,
      "pageSize": _vm.pageSize,
      "totalCount": _vm.totalCount
    },
    on: {
      "size-change": _vm.sizeChangeHandle,
      "current-change": _vm.currentChangeHandle
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }